import * as React from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { creditCardExpirationDate } from '@sales-center/common'
import { PaymentMethod } from '@user/store/payments'

export const columns: GridColDef<PaymentMethod>[] = [
  { field: 'nameOnCard', headerName: 'Name', sortable: false, width: 240 },
  {
    field: 'accountType',
    headerName: 'Account Type',
    sortable: false,
    width: 240,
  },
  {
    field: 'accountNumber',
    headerName: 'Account Number',
    sortable: false,
    width: 240,
  },
  {
    field: 'expirationDate',
    headerName: 'Expiration',
    renderCell: (cellValues) =>
      creditCardExpirationDate(cellValues.row.expirationDate),
    sortable: false,
    width: 240,
  },
  {
    field: 'isPrimary',
    headerName: 'Primary',
    sortable: false,
    width: 240,
    renderCell: (cellValues) =>
      cellValues.row.isPrimary && (
        <CheckCircleIcon
          color="primary"
          fontSize="small"
          data-test-id={`primaryPaymentIcon-${cellValues.row.id}`}
        />
      ),
  },
]
